export const EMPTY_PARTS = [
  'container',
  'headline',
  'description',
  'ctaButton',
] as const;
